import {
  IBrand,
  PracticeSetupStepCategory,
  PracticeSetupStepId,
} from '@principle-theorem/principle-core/interfaces';
import { Firestore } from '@principle-theorem/shared';
import { from } from 'rxjs';
import { map, switchMap } from 'rxjs/operators';
import { Brand } from '../../brand';
import { IPracticeSetupStepDefinition } from './practice-setup-step.types';
import { initRawSchema, toParagraphContent } from '@principle-theorem/editor';

export const treatmentTemplatesSetupStep: IPracticeSetupStepDefinition = {
  id: PracticeSetupStepId.TreatmentTemplatesSetup,
  category: PracticeSetupStepCategory.ConditionsAndTreatments,
  title: 'Set Up Treatment Templates',
  description: initRawSchema([
    toParagraphContent(
      `Treatment Templates are pre-configured treatment options that serve as starting points for patient appointments. They are commonly used for broad appointment types such as consultations, periodic exams, and emergency bookings, where the specific treatments to be performed will be determined during the visit itself.`
    ),
    toParagraphContent(
      `Templates serve two important functions in Principle. First, they provide a booking option for patients who do not yet have an active Treatment Plan, ensuring your front desk team always has a suitable appointment type to offer. Second, they are used to make treatment options available through your online booking system, so configuring them correctly is essential if your practice accepts online booking.`
    ),
  ]),
  dependsOn: [
    PracticeSetupStepId.TreatmentsSetup,
    PracticeSetupStepId.MultiTreatmentsSetup,
    PracticeSetupStepId.StaffSetup,
  ],
  getRoute: (brand, _practice) =>
    `settings/brand/${brand.ref.id}/treatment-templates`,
  validate$: (practice$, _step, _options) => {
    return practice$.pipe(
      switchMap((practice) => {
        const brandRef = Firestore.getParentDocRef<IBrand>(practice.ref);
        return from(Brand.treatmentTemplates({ ref: brandRef })).pipe(
          map((templates) => {
            if (templates.length === 0) {
              return {
                valid: false,
                reason: 'No treatment templates have been created',
              };
            }

            return { valid: true };
          })
        );
      })
    );
  },
  pageVisitTracking: {
    routes: ['settings/brand/{brandId}/treatment-templates'],
    validationMode: 'any',
  },
};
